import React from 'react';

import {formatTime, formatDate} from 'utils/datetime';

import './styles.css';

const ActivityLogEntry = ({
  activityIcon,
  action,
  description,
  actionDateTime
}) => (
  <div className="ActivityLogEntry colab-sidepadding-2">
    <div className="ActivityLogEntry__timestamp">
      <div className="ActivityLogEntry__timestamp__item">
        {formatTime(actionDateTime)}
      </div>
      <div className="ActivityLogEntry__timestamp__item">
        {formatDate(actionDateTime)}
      </div>
    </div>
    <div className="ActivityLogEntry__checkpoint">
      <div className="ActivityLogEntry__iconImageContainer">
        <img src={activityIcon} alt="ActivityIcon" />
      </div>
      <div className="ActivityLogEntry__vericalLine" />
    </div>
    <div className="ActivityLogEntry__description colab-sidepadding-1">
      <div className="colab-bold">{action}</div>
      <div>{description}</div>
    </div>
  </div>
);

export default ActivityLogEntry;
